import React from "react";
import { Route } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PublicRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      component={(props) => (
        <div>
          <Navbar />
          <Component {...props} />
          <Footer />
        </div>
      )}
    />
  );
};

export default PublicRoute;
